import { render, staticRenderFns } from "./ExamCardFormula.vue?vue&type=template&id=f02f8c50&scoped=true&"
import script from "./ExamCardFormula.vue?vue&type=script&lang=ts&"
export * from "./ExamCardFormula.vue?vue&type=script&lang=ts&"
import style0 from "./ExamCardFormula.vue?vue&type=style&index=0&id=f02f8c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02f8c50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
